import type { ReactNode } from "react";

import type { LinkTarget } from "@/components/link";
import { CatalogOfferPrices } from "@/components/marketplace/CatalogOfferPrices";
import { DealOfferTags } from "@/components/marketplace/deal-offer-tags";
import { ForSaleBadge } from "@/components/marketplace/for-sale-badge";
import {
  OfferSummaryBadge,
  type OfferSummary,
  type OfferSummaryBadgeMode,
  type OfferSummaryBadgeVariant,
} from "@/components/marketplace/offer-summary-badge";
import { cn } from "@/lib/utils";
import type { OfferSummaryByCondition } from "@garimpa/lib/offerConditions";

export function AlbumCardDetails(props: {
  albumTypeLabel: string | null;
  footer: ReactNode;
  headingId?: string;
  listingCount?: number;
  listingCurrency?: string;
  listingMaxPrice?: string;
  listingMinPrice?: string;
  offerSummary?: OfferSummary | null;
  offerSummaryByCondition?: OfferSummaryByCondition<OfferSummary>;
  offerDestination: LinkTarget;
  offerSummaryMode?: OfferSummaryBadgeMode;
  offerSummaryVariant?: OfferSummaryBadgeVariant;
  releaseId?: string | null;
  subtitle?: string | null;
  tags: ReactNode;
  title: string;
}) {
  return (
    <div className={cn("px-2 pt-3", !props.footer && "pb-2")}>
      <h3 id={props.headingId} className="font-bold text-base truncate">
        {props.title}
      </h3>
      {props.subtitle && <p className="text-sm text-muted-foreground truncate">{props.subtitle}</p>}
      {props.tags}
      {props.offerSummary?.tags.length ? (
        <div className="mt-1 flex flex-wrap gap-1.5">
          <DealOfferTags tags={props.offerSummary.tags} />
        </div>
      ) : null}
      {props.albumTypeLabel && (
        <div className="mt-1 flex min-w-0">
          <span className="inline-block max-w-full truncate rounded bg-secondary px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
            {props.albumTypeLabel}
          </span>
        </div>
      )}
      {props.listingCount !== undefined && props.listingCount > 0 && (
        <ForSaleBadge
          className="mt-1"
          count={props.listingCount}
          minPrice={props.listingMinPrice}
          maxPrice={props.listingMaxPrice}
          currency={props.listingCurrency}
        />
      )}
      {props.offerSummaryByCondition ? (
        <CatalogOfferPrices
          summary={props.offerSummaryByCondition}
          destination={props.offerDestination}
        />
      ) : (
        props.offerSummary && (
          <div className="mt-1 flex min-w-0">
            <OfferSummaryBadge
              mode={props.offerSummaryMode}
              offerSummary={props.offerSummary}
              releaseId={props.releaseId}
              variant={props.offerSummaryVariant}
            />
          </div>
        )
      )}
    </div>
  );
}
